import React from 'react'
import StarRating from '../../shared/StarRating'

export default function Reviews( {TESTIMONIALS = []}) {
  return (
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-black text-center mb-12">What Our <span className="text-orange-500">Customers Say</span></h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {TESTIMONIALS.map(t => (
              <div key={t.id} className="bg-gray-50 rounded-2xl p-6 hover:shadow-md transition-shadow">
                <StarRating rating={t.rating} size="md" />
                <p className="text-sm text-gray-600 mt-3 mb-4 leading-relaxed">"{t.text}"</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-400 to-red-500 flex items-center justify-center text-white font-bold text-xs">{t.avatar}</div>
                  <div>
                    <div className="font-semibold text-sm text-gray-900">{t.name}</div>
                    <div className="text-xs text-gray-400">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
  )
}
